<template>
  <div class="image-page-wrapper">
    <el-row v-if="!permissionDenied" class="content-container">
      <el-row class="header-section">
        <el-col :span="24">
          <el-card v-if="user" class="info-card-glass" :body-style="{ padding: '20px' }">
            <div class="user-meta-wrapper">
              <div class="user-avatar-box">
                <el-avatar :size="64" :src="user.avatarUrl" class="custom-avatar shadow-soft" />
              </div>
              <div class="user-info-main">
                <div class="top-line">
                  <router-link class="user-name-link" :to="`/user/${user.userId}?tab=image&page=1`">
                    {{ user.screenName }}的相册
                  </router-link>
                  <div class="action-btns">
                    <el-button
                      :type="followButton.text === '关注' ? 'danger' : 'info'"
                      size="mini"
                      round
                      :icon="followButton.icon"
                      class="action-btn"
                      @click="followUser(user.userId)"
                    >
                      {{ followButton.text }}
                    </el-button>
                    <el-button
                      type="default"
                      size="mini"
                      round
                      icon="el-icon-message"
                      class="action-btn message-btn"
                      @click="sendMessage(user.userId)"
                    >
                      发消息
                    </el-button>
                  </div>
                </div>
                <div class="album-title-line">
                  <h1 class="album-display-name">{{ data.albumName }}</h1>
                  <span class="image-count-tag"><i class="el-icon-picture-outline" /> {{ totalSize }} P</span>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="12" class="image-grid">
        <el-col
          v-for="(image, index) in dataList"
          :key="image.thumbnailUrl"
          :md="6"
          :sm="8"
          :xs="12"
          class="grid-item"
        >
          <div class="image-card-item" @click="showImages(index)">
            <el-image
              lazy
              fit="cover"
              class="gallery-img"
              :src="image.thumbnailUrl"
            >
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading" />
              </div>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline" />
              </div>
            </el-image>
            <div class="img-hover-mask">
              <i class="el-icon-zoom-in" />
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row class="pagination-section">
        <el-pagination
          background
          :small="screenWidth <= 768"
          hide-on-single-page
          layout="total, prev, pager, next"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="totalSize"
          @current-change="handleCurrentChange"
        />
      </el-row>
    </el-row>

    <div v-else class="denied-wrapper">
      <permission-denied-card :text-object="textObject" />
    </div>
  </div>
</template>

<script>
import PermissionDeniedCard from '@/components/card/PermissionDeniedCard'
import { followUser, getUserInfo, unfollowUser } from '@/api/user'
import { getAlbumItems } from '@/api/vod'

export default {
  name: 'AlbumImage',
  metaInfo: {
    meta: [
      { name: 'referrer', content: 'no-referrer' }
    ]
  },
  components: { PermissionDeniedCard },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      currentPage: 1,
      pageSize: 12,
      totalSize: 0,
      dataList: [],
      albumId: null,
      user: null,
      followButton: {
        icon: 'el-icon-plus',
        text: '关注'
      },
      permissionDenied: false,
      textObject: {
        content: '相册',
        route: '/image'
      },
      data: {}
    }
  },
  created() {
    this.albumId = this.$route.params.albumId
    this.getAlbumItemsWrapper()
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth
    }
  },
  methods: {
    handleCurrentChange(pageNumber) {
      this.currentPage = pageNumber
      this.dataList = []
      this.getAlbumItemsWrapper()
      scrollTo({ top: 0, behavior: 'smooth' })
    },
    getAlbumItemsWrapper() {
      const queryInfo = {
        albumId: this.albumId,
        pn: this.currentPage
      }
      getAlbumItems(queryInfo).then(resp => {
        if (resp.code === 0) {
          const albumInfo = resp.data.albumInfo
          this.userId = albumInfo.createBy
          document.title = '相册 - ' + albumInfo.albumName

          const images = resp.data.imageList
          this.dataList = images.list
          this.totalSize = images.totalSize
          getUserInfo(this.userId).then(resp => {
            if (resp.code === 0) {
              this.user = resp.data
            } else {
              this.$notify.error({ message: resp.msg, type: 'warning', duration: 3000 })
            }
          })
        } else if (resp.code === 2) {
          this.$router.push('/404')
        } else {
          this.permissionDenied = true
        }
      }).catch(error => {
        this.$notify.error({ message: error.message, type: 'error', duration: 3000 })
      })
    },
    followUser(userId) {
      if (this.followButton.text === '关注') {
        followUser(userId).then(resp => {
          if (resp.code === 0) {
            this.followButton.text = '已关注'
            this.followButton.icon = 'el-icon-check'
          }
        })
      } else {
        unfollowUser(userId).then(resp => {
          if (resp.code === 0) {
            this.followButton.text = '关注'
            this.followButton.icon = 'el-icon-plus'
          }
        })
      }
    },
    sendMessage(userId) { console.log('发送消息') },
    showImages(index) {
      const imageUrls = this.dataList.map(i => i.originalUrl)
      this.$viewerApi({
        images: imageUrls,
        options: {
          initialViewIndex: index,
          movable: true,
          fullscreen: false,
          keyboard: true
        }
      })
    }
  }
}
</script>

<style scoped>
.image-page-wrapper {
  background-color: #f6f8fa;
  min-height: 100vh;
  padding-bottom: 40px;
}

.content-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 6%;
}

/* 头部卡片样式 */
.header-section {
  margin-bottom: 25px;
}

.info-card-glass {
  border: none;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
}

.user-meta-wrapper {
  display: flex;
  align-items: center;
  gap: 20px;
}

.user-name-link {
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  color: #409EFF;
  transition: color 0.3s;
}

.user-name-link:hover {
  color: #66b1ff;
}

.top-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.user-info-main {
  flex-grow: 1;
}

.album-title-line {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
}

.album-display-name {
  font-size: 22px;
  margin: 0;
  color: #303133;
  font-weight: 700;
}

.image-count-tag {
  background: #f0f2f5;
  color: #909399;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
}

.action-btns {
  display: flex;
  gap: 8px;
}

/* 图片网格样式 */
.image-grid {
  margin-top: 10px;
}

.grid-item {
  margin-bottom: 15px;
}

.image-card-item {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  aspect-ratio: 3 / 4; /* 强制比例统一，像相册集一样整齐 */
}

.image-card-item:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

.gallery-img {
  width: 100%;
  height: 100%;
  display: block;
  transition: transform 0.6s ease;
}

.image-card-item:hover .gallery-img {
  transform: scale(1.08);
}

.img-hover-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s;
  color: white;
  font-size: 24px;
}

.image-card-item:hover .img-hover-mask {
  opacity: 1;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}

/* 分页样式 */
.pagination-section {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .content-container {
    padding: 10px 3%;
  }

  .user-meta-wrapper {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .top-line {
    flex-direction: column;
    gap: 10px;
  }

  .album-title-line {
    justify-content: center;
  }

  .album-display-name {
    font-size: 18px;
  }

  .image-card-item {
    aspect-ratio: 1 / 1; /* 手机端使用正方形更紧凑 */
  }

  .custom-avatar {
    width: 50px !important;
    height: 50px !important;
  }
}
</style>
